import { File } from './../../models/files/files.model';
export class LoggedUser {
    token: string;
    username: string;
    expires: number;
    file: File;

    constructor(options: {
        token: string,
        username: string,
        expires: number,
        file: File
    }) {
        this.token = options.token;
        this.username = options.username;
        this.expires = options.expires;
        this.file = options.file;
    }
}
